import styles from "./checkbox.module.css";
import cn from "classnames";
interface CheckboxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export function Checkbox({ label, checked, onChange, disabled = false }: CheckboxProps) {
  return (
    <label className={cn(styles.container, { [styles.disabled]: disabled })}>
      <div className={styles.checkboxWrapper}>
        {/* Hidden Native Checkbox */}
        <input
          type="checkbox"
          className={styles.srOnly}
          checked={checked}
          onChange={(e) => !disabled && onChange(e.target.checked)}
          disabled={disabled}
        />

        {/* Custom Checkbox Box */}
        <div className={cn(styles.box, checked ? styles.checked : styles.unchecked)}>
          {/* Checkmark Icon */}
          <svg
            className={cn(styles.icon, checked ? styles.iconVisible : styles.iconHidden)}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
      </div>

      {/* Label Text */}
      <span>{label}</span>
    </label>
  );
}
